import { EntityModel } from 'src/core/services/data/models';
import { DataService, property } from 'src/core/services/data.service';
import { BookemZulu as Model } from 'src/core/services/data/JayDataContext';
import { computed } from 'mobx';

export class ProductCategoryListDataService extends DataService<typeof Model.Products.Logic.ViewModels.ProductCategorySummary, Model.Products.Logic.ViewModels.ProductCategorySummary, ProductCategorySummary> {
	protected map(entity: Model.Products.Logic.ViewModels.ProductCategorySummary): ProductCategorySummary {
		return new ProductCategorySummaryModel(entity);
	}

	public static make(context?: any): ProductCategoryListDataService {
		return new ProductCategoryListDataService(context, ctx => ctx.ProductCategorySummaries);
	}
}

export class ProductCategorySummaryModel extends EntityModel<Model.Products.Logic.ViewModels.ProductCategorySummary, ProductCategorySummary> implements ProductCategorySummary {
	@property<ProductCategorySummaryModel>(o => o.entity.id, (o, value) => o.entity.id = value)
	public id: number;

	@property<ProductCategorySummaryModel>(o => o.entity.displayName, (o, value) => o.entity.displayName = value)
	public displayName: string;

	@property<ProductCategorySummaryModel>(o => o.entity.productType, (o, value) => o.entity.productType = value)
	public productType: Model.Core.Models.ProductType;

	@computed
	public get productTypeText(): string {
		switch (this.entity.productType) {
			case 0:
				return 'General';
			case 1:
				return 'Accomodation';
			case 2:
				return 'Car rent';
			case 3:
				return 'Transfer';
			case 4:
				return 'Flight';
			case 5:
				return 'Room';
			case 6:
				return 'Supplement/Discount';
			case 7:
				return 'Sales Adjustment';
			case 8:
				return 'Accounting Adjustment';
			case 9:
				return 'Tour';
			case 10:
				return 'Package';
		}
		return null;
	}

	@property<ProductCategorySummaryModel>(o => o.entity.parentCategoryId, (o, value) => o.entity.parentCategoryId = value)
	public parentCategoryId?: number;

	@property<ProductCategorySummaryModel>(o => o.entity.parentCategoryDisplayName, (o, value) => o.entity.parentCategoryDisplayName = value)
	public parentCategoryDisplayName: string;

	@property<ProductCategorySummaryModel>(o => o.entity.hasChildren, (o, value) => o.entity.hasChildren = value)
	public hasChildren: boolean;

	@property<ProductCategorySummaryModel>(o => o.entity.canHaveChildrenOfType, (o, value) => o.entity.canHaveChildrenOfType = value)
	public canHaveChildrenOfType?: number;

	@computed
	public get canHaveChildrenOfTypeText(): string {
		switch (this.entity.canHaveChildrenOfType) {
			case 0:
				return 'General';
			case 1:
				return 'Accomodation';
			case 2:
				return 'Car rent';
			case 3:
				return 'Transfer';
			case 4:
				return 'Flight';
			case 5:
				return 'Room';
			case 6:
				return 'Supplement/Discount';
			case 7:
				return 'Sales Adjustment';
			case 8:
				return 'Accounting Adjustment';
			case 9:
				return 'Tour';
			case 10:
				return 'Package';
			default:
				return null;
		}
	}

	@property<ProductCategorySummaryModel>(o => o.entity.canHaveSupplementsOrDiscounts, (o, value) => o.entity.canHaveSupplementsOrDiscounts = value)
	public canHaveSupplementsOrDiscounts: boolean;

	@property<ProductCategorySummaryModel>(o => o.entity.canHaveContracts, (o, value) => o.entity.canHaveContracts = value)
	public canHaveContracts: boolean;

	@property<ProductCategorySummaryModel>(o => o.entity.taxonomicFields, (o, value) => o.entity.taxonomicFields = value)
	public taxonomicFields: string[];
}



// WEBPACK FOOTER //
// ./src/app/products/product-categories/list/product-category-list.data.ts